import { Component, Inject } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { FeatureInformation, getFeatureInformation } from './access-restricted-content';
import { FeatureInfoService } from './feature-info.service';

@Component({
  template: `
    <mat-dialog-content class="restricted-dialog">
      <ng-container *ngIf="info$ | async as info">
        <app-access-restricted-content
          userEventCategory="restricted-button-action"
          [featureInfo]="info"
          (ctaClicked)="ctaClicked()"
        ></app-access-restricted-content>
      </ng-container>
    </mat-dialog-content>
  `,
  styleUrls: ['./access-dialog.component.scss'],
})
export class AccessRestrictedDialogComponent {
  private featureId: string;
  public info$: Observable<FeatureInformation>;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { featureId: string },
    public dialog: MatDialog,
    private readonly featureInfoService: FeatureInfoService,
  ) {
    this.featureId = data.featureId;
    this.info$ = this.featureInfoService.getNextSubscriptionTierWithFeature(this.featureId).pipe(
      map((nextSubscriptionId) => {
        const featureInfo = getFeatureInformation(this.featureId);
        featureInfo.minUpgradeLevel = nextSubscriptionId;
        return featureInfo;
      }),
    );
  }

  ctaClicked(): void {
    this.dialog.closeAll();
  }
}
